/* Header Kiomia.
   Tutto e' agganciato per delega su document: cosi' funziona a prescindere
   da quando parte lo script, sopravvive ai ridisegni del Theme Editor e non
   dipende dal fatto che il DOM sia gia' pronto. */
(function () {
  var CHIUSURA = null;

  function radice() { return document.querySelector('[data-km-hd]'); }
  function pannello() { return document.querySelector('[data-km-hd-panel]'); }

  /* ---------- Mega menu ---------- */
  function chiudiMega(tranne) {
    var voci = document.querySelectorAll('[data-km-mm]');
    for (var i = 0; i < voci.length; i++) {
      if (voci[i] === tranne) continue;
      voci[i].classList.remove('is-on');
      var t = voci[i].querySelector('[data-km-mm-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
    if (!tranne) document.body.classList.remove('km-mm-aperto');
  }

  function apriMega(v) {
    if (!v) return;
    if (CHIUSURA) { clearTimeout(CHIUSURA); CHIUSURA = null; }
    chiudiMega(v);
    v.classList.add('is-on');
    document.body.classList.add('km-mm-aperto');
    var t = v.querySelector('[data-km-mm-trigger]');
    if (t) t.setAttribute('aria-expanded', 'true');
  }

  function chiudiConRitardo() {
    if (CHIUSURA) clearTimeout(CHIUSURA);
    CHIUSURA = setTimeout(function () { chiudiMega(null); }, 140);
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var voce = t.closest('[data-km-mm]');
    if (voce) { apriMega(voce); return; }
    /* Fuori da qualsiasi voce e fuori dal pannello: chiudi. */
    if (document.body.classList.contains('km-mm-aperto') && !t.closest('.km-mm')) chiudiConRitardo();
  });

  document.addEventListener('focusin', function (e) {
    var voce = e.target.closest ? e.target.closest('[data-km-mm]') : null;
    if (voce) apriMega(voce);
    else if (e.target.closest && !e.target.closest('.km-mm')) chiudiMega(null);
  });

  /* ---------- Pannello a tutto schermo (mobile) ---------- */
  function mostraPannello(si) {
    var p = pannello();
    if (!p) return;
    var apri = document.querySelector('[data-km-hd-open]');
    if (si) {
      p.hidden = false;
      void p.offsetHeight;
      p.classList.add('is-on');
      document.body.classList.add('km-hd-bloccato');
      var primo = p.querySelector('a, button');
      if (primo) primo.focus();
    } else {
      p.classList.remove('is-on');
      document.body.classList.remove('km-hd-bloccato');
      setTimeout(function () { p.classList.contains('is-on') || (p.hidden = true); }, 220);
      if (apri) apri.focus();
    }
    if (apri) apri.setAttribute('aria-expanded', si ? 'true' : 'false');
  }

  function mostraCerca(si) {
    var r = radice();
    if (!r) return;
    var barra = r.querySelector('[data-km-hd-barra]');
    if (!barra) return;
    barra.hidden = !si;
    var bs = r.querySelectorAll('[data-km-hd-cerca]');
    for (var j = 0; j < bs.length; j++) bs[j].setAttribute('aria-expanded', si ? 'true' : 'false');
    var campo = r.querySelector('[data-km-hd-input]');
    if (si && campo) campo.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-km-hd-open]')) { mostraPannello(true); return; }
    if (t.closest('[data-km-hd-close]')) { mostraPannello(false); return; }
    if (t.closest('[data-km-mm-close]')) { chiudiMega(null); return; }
    if (t.closest('[data-km-hd-cerca-chiudi]')) { mostraCerca(false); return; }

    if (t.closest('[data-km-hd-cerca]')) {
      var r = radice();
      var barra = r && r.querySelector('[data-km-hd-barra]');
      mostraCerca(barra ? barra.hidden : true);
      return;
    }

    /* Fisarmonica dentro il pannello */
    var sub = t.closest('[data-km-sub]');
    if (sub) {
      var giu = sub.nextElementSibling;
      if (giu) {
        var aperto = !giu.hidden;
        giu.hidden = aperto;
        sub.setAttribute('aria-expanded', aperto ? 'false' : 'true');
        sub.classList.toggle('is-on', !aperto);
      }
      return;
    }

    /* Su touch il primo tocco sulla voce madre apre invece di navigare. */
    var trig = t.closest('[data-km-mm-trigger]');
    if (trig && window.matchMedia('(hover: none)').matches) {
      var voce = trig.closest('[data-km-mm]');
      if (voce && !voce.classList.contains('is-on')) { e.preventDefault(); apriMega(voce); }
      return;
    }

    /* Un link dentro il pannello chiude tutto. */
    if (t.closest('[data-km-hd-panel]') && t.closest('a')) mostraPannello(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      chiudiMega(null);
      var p = pannello();
      if (p && !p.hidden) mostraPannello(false);
      mostraCerca(false);
      return;
    }
    if (e.key === 'ArrowDown' && e.target.closest && e.target.closest('[data-km-mm-trigger]')) {
      e.preventDefault();
      var voce = e.target.closest('[data-km-mm]');
      apriMega(voce);
      var primo = voce.querySelector('.km-mm a');
      if (primo) primo.focus();
    }
  });
})();